import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vehicleMatchComponent from './vehicleMatch.component';

let vehicleMatchModule = angular.module('vehicleMatch', [
  uiRouter
])

.component('vehicleMatch', vehicleMatchComponent)

.name;

export default vehicleMatchModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/vehicleMatch/vehicleMatch.js